import { Link } from 'react-router-dom';
import { ArrowRight, Briefcase, MapPin, Clock } from 'lucide-react';

const CareersPage = () => {
  return (
    <main>
      {/* Hero */}
      <section className="relative min-h-[50vh] flex items-center overflow-hidden">
        <div className="absolute inset-0 bg-surface" />
        <div className="absolute inset-0 hero-gradient" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 pt-32 pb-16 w-full">
          <p className="text-xs font-mono uppercase tracking-[0.3em] text-amber mb-4">Join Our Team</p>
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-white tracking-tight" data-testid="careers-page-title">
            Careers
          </h1>
          <p className="text-slate-300 mt-4 max-w-xl">
            Be part of an innovative team building world-class technology solutions.
          </p>
        </div>
      </section>

      {/* Open Positions */}
      <section className="py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center mb-16">
            <h2 className="font-heading text-3xl font-bold text-white mb-4 tracking-tight">Open Positions</h2>
            <p className="text-slate-400 text-sm leading-relaxed">
              We're always looking for talented people. Send your resume to{' '}
              <a href="mailto:hr@jhaishna.com" className="text-amber hover:underline">hr@jhaishna.com</a>
            </p>
          </div>

          <div className="space-y-4 max-w-3xl mx-auto">
            {[
              { title: 'Oracle BRM Consultant', location: 'Vijayawada / Remote', type: 'Full-time' },
              { title: 'Full Stack Developer', location: 'Vijayawada', type: 'Full-time' },
              { title: 'Cloud Engineer', location: 'Remote', type: 'Full-time' },
              { title: 'QA Engineer', location: 'Vijayawada', type: 'Full-time' },
            ].map((job) => (
              <div key={job.title} className="bg-surface border border-white/10 rounded-sm p-6 card-hover group flex items-center justify-between" data-testid={`job-${job.title.toLowerCase().replace(/\s+/g, '-')}`}>
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 bg-amber/10 rounded-sm flex items-center justify-center">
                    <Briefcase className="w-5 h-5 text-amber" />
                  </div>
                  <div>
                    <h3 className="font-heading text-base font-bold text-white">{job.title}</h3>
                    <div className="flex items-center gap-4 mt-1">
                      <span className="text-xs text-slate-400 flex items-center gap-1">
                        <MapPin className="w-3 h-3" /> {job.location}
                      </span>
                      <span className="text-xs text-slate-400 flex items-center gap-1">
                        <Clock className="w-3 h-3" /> {job.type}
                      </span>
                    </div>
                  </div>
                </div>
                <a href="mailto:hr@jhaishna.com" className="text-amber text-sm font-medium inline-flex items-center gap-1 hover:gap-2 transition-all">
                  Apply <ArrowRight className="w-3.5 h-3.5" />
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-surface/30 border-y border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="font-heading text-2xl font-bold text-white mb-4">Don't see the right role?</h2>
          <p className="text-slate-400 mb-6 text-sm">Send your resume to hr@jhaishna.com and we'll keep you in mind for future opportunities.</p>
          <a href="mailto:hr@jhaishna.com" className="btn-amber rounded-sm text-sm inline-flex items-center gap-2">
            Send Resume <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </section>
    </main>
  );
};

export default CareersPage;
